export default "__VITE_ASSET__DyGnEhbd__"